"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACILITY_MESSAGES = {
    getFacilitiesPccLoginCredential: {
        message: 'Login cannot be empty',
    },
    getFacilitiesPccPasswordCredential: {
        message: 'Password cannot be empty',
    },
    getFacilitiesPccIds: {
        message: 'Facilities should be only number array.',
    },
    saveFacilityPayerGroupFacility: {
        message: 'Facility cannot be empty',
    },
    saveFacilityPayerGroupId: {
        message: 'Id cannot be empty',
    },
    saveFacilityPayerGroupName: {
        message: 'Group name cannot be empty',
    },
};
